<div class="modal-header">
  <h2 i18n="@@cropper.crop_image">Crop Image</h2>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.close(null)">
    <svg version="1.1" x="0px" y="0px" width="14" height="14" viewBox="0 0 14 14">
      <path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
    </svg>
  </button>
</div>
<div class="modal-body">
    <image-cropper 
      [imageChangedEvent]="imageChangedEvent" 
      [cropperMinWidth]="cropperConfig.minWidth"
      [aspectRatio]="cropperConfig.aspectRatio"
      format="png" 
      (imageCropped)="imageCropped($event)" 
      (imageLoaded)="imageLoaded()" 
      (cropperReady)="cropperReady($event)"
      (loadImageFailed)="loadImageFailed()">
    </image-cropper>
</div>
<div class="modal-footer">
  <button type="button" class="tu-btn blue" i18n="@@cropper.crop_image" (click)="closeModal(croppedImage)" >Crop Image</button>
  <button type="button" class="tu-btn pink" i18n="@@cropper.cancel" (click)="activeModal.dismiss(null)">Cancel</button>
</div>